import React, {  useEffect }  from "react";
import { Container } from "@mui/material";
import Banner from "./Home/Banner/Banner";
import CategoryCards from "./Home/CategoryCards/CategoryCards";
import SaleBanner from "./Home/SaleBanner/SaleBanner";
import BestSellers from "./Home/BestSellers/BestSellers";
import RecentNews from "./Home/RecentNews/RecentNews";
import Footer from "./Footer/Footer";
import Brand from "./Brands/Brands";

const HomePage = () => {

  return (
    <Container maxWidth="100%"   sx={{ marginTop: "130px" }}>
      
      <Banner />
      <CategoryCards />
      
      <BestSellers />
      <SaleBanner title="Happy House" subtitle="Summer Sale" bgColor="#4CAF50" />
     </Container>
  );
};

export default HomePage;
